/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Cards({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M10.6 6a.6.6 0 0 1-.6.6H6a.6.6 0 1 1 0-1.2h4a.6.6 0 0 1 .6.6M10 10.1a.6.6 0 1 0 0-1.2H6a.6.6 0 0 0 0 1.2z" /><path fill="currentColor" fillRule="evenodd" d="M3.143 3.4A2.6 2.6 0 0 1 5.5 1.9h5a2.6 2.6 0 0 1 2.357 1.5h1.393a1.6 1.6 0 0 1 1.6 1.6v6a1.6 1.6 0 0 1-1.6 1.6h-1.393a2.6 2.6 0 0 1-2.357 1.5h-5a2.6 2.6 0 0 1-2.357-1.5H1.75A1.6 1.6 0 0 1 .15 11V5a1.6 1.6 0 0 1 1.6-1.6zM2.9 4.6H1.75a.4.4 0 0 0-.4.4v6c0 .22.179.4.4.4H2.9zm10.2 6.8V4.6h1.15c.22 0 .4.18.4.4v6a.4.4 0 0 1-.4.4zM5.5 3.1a1.4 1.4 0 0 0-1.4 1.4v7a1.4 1.4 0 0 0 1.4 1.4h5a1.4 1.4 0 0 0 1.4-1.4v-7a1.4 1.4 0 0 0-1.4-1.4z" clipRule="evenodd" /></svg>;
}
;